import { useEffect, useMemo, useRef, useState } from 'react';
import { convertToTwoDecimalPlaces } from 'components/Charts/Tooltip';
import { setTotalFleetDetails } from 'store/production.slice';
import {
  calculateCurrentDailyAverage,
  calculateDailyMovingAverage,
  getFleetProduction,
} from './AllFleet/utils';
import { useAppDispatch } from 'store/hook';
import {
  type fleetData,
  type loaderDailyAveragesType,
} from 'types/production.types';
import { calculateUtilCurrentDailyAverage } from 'views/Utilization/utils';
import { type utilizationFleetData } from 'types/utilization.types';

export const useRollingDailyAverage = (
  data: {
    allFleet: fleetData;
    loaders: loaderDailyAveragesType;
  },
  selectedChartSource: any
) => {
  const [rollingDailyAverage, setRollingDailyAverage] = useState<number>(0);
  const dispatch = useAppDispatch();

  let chartData: any = [];
  const fleetPeriodSummary = data.allFleet.fleetPeriodSummary;

  const selectedSource: any = Array.isArray(fleetPeriodSummary)
    ? fleetPeriodSummary?.find(
        (item) => item.time_range === getFleetProduction(selectedChartSource)
      )
    : null;
  if (selectedSource?.daily_production) {
    chartData = Object.keys(selectedSource?.daily_production).map((date) => ({
      date,
      value: convertToTwoDecimalPlaces(selectedSource?.daily_production[date]),
    }));
  }

  const rdaRef = useRef<number | null>(null); // Initialize ref to track the last dispatched value

  useEffect(() => {
    const result = calculateDailyMovingAverage(chartData, 2);

    if (result?.length > 0 && Array.isArray(result)) {
      const rda = result[result.length - 1].movingAverage ?? 0;

      if (rdaRef.current !== rda) {
        rdaRef.current = rda;
        setRollingDailyAverage(rda);
        dispatch(setTotalFleetDetails({ rollingDailyAverageFromChart: rda }));
      }
    }
  }, [chartData]);

  return rollingDailyAverage;
};

export const useCurrentDailyAvgUtil = (utilData: {
  allFleet: utilizationFleetData;
}) => {
  const currentDailyAvg = useMemo(() => {
    return calculateUtilCurrentDailyAverage(
      utilData.allFleet.fleetPeriodSummary.fleet ?? []
    );
  }, [utilData.allFleet.fleetPeriodSummary.fleet]);
  return currentDailyAvg;
};

export const useCurrentDailyAvgProd = (data: {
  allFleet: fleetData;
  loaders: loaderDailyAveragesType;
}) => {
  const currentDailyAvg = useMemo(() => {
    return calculateCurrentDailyAverage(data.allFleet.fleetPeriodSummary ?? []);
  }, [data.allFleet.fleetPeriodSummary]);
  return currentDailyAvg;
};
